import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    appointment_id: '',
    user_id: '',
    update_flag: false
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    getAppointmentId(state, id) {
        state.appointment_id = id;
    },
    getUserId(state,id) {
        state.user_id = id;
    },
    isUpdate(state,flag) { // 服务新增时传状态给mainserive 需重新渲染
        state.update_flag = flag;
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/vuex/store.js